import React from 'react';
import PropTypes from 'prop-types';

const Webcam = (props) => {
  const { title, link, thumbnail } = props.children;

  return (
    <div className="webcam">
      <a href={link.url} target="_blank" rel="noopener noreferrer">
        <img src={thumbnail} alt={title} className="webcam-image" />
      </a>

      <div className="webcam-text">
        <p className="webcam-title">{title}</p>
      </div>
    </div>
  );
};

Webcam.propTypes = {
  children: PropTypes.object,
  id: PropTypes.number,
};

export default Webcam;
